import React from 'react';

// Telegram workflow components will be implemented here
export const telegramNodeTypes = {};
export const telegramEdgeTypes = {};
export const telegramSupportedMessageTypes = ['text', 'image', 'audio', 'video', 'file', 'sticker', 'animation', 'voice'];
export const telegramNodeTemplates = {};

export const TelegramWorkflow: React.FC = () => {
  return React.createElement('div', null, 'Telegram Workflow - Coming Soon');
};

export default TelegramWorkflow;
